export default __webpack_public_path__ + "static/globe-prince-assise-c5cac7a28ff7e54305b1f3e72c08f070.svg";